import { useEffect, useState } from 'react';
import api from '../../../Component/axios_Interceptor/api';
import { SERVER_ADDRESS } from '../../../Component/server';
import './WarehouseImportGroups.css';
export type ImportGroups = { groupSeqs: number[]; newGroupName?: string };
export default function WarehouseImportGroups({ value, onChange, disabled }: { value: ImportGroups; onChange: (value: ImportGroups) => void; disabled: boolean }) {
  const [groups, setGroups] = useState<{ seq: number; name: string }[]>([]);
  const [error, setError] = useState('');
  const [create, setCreate] = useState(false);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); setError('');
    api.get(`${SERVER_ADDRESS}product/warehouse/filters`, { signal: controller.signal }).then(response => {
      if (!controller.signal.aborted) setGroups(response.data.groups);
    }).catch(() => { if (!controller.signal.aborted) setError('그룹을 불러오지 못했습니다.'); });
    return () => controller.abort();
  }, [version]);
  return <fieldset className="warehouse-import-groups" disabled={disabled}>
    <legend>그룹 지정 <span>선택</span></legend>
    <div className="warehouse-import-group-list">{groups.map(group => <label key={group.seq}>
      <input type="checkbox" checked={value.groupSeqs.includes(Number(group.seq))}
        onChange={event => onChange({ ...value, groupSeqs: event.target.checked ? [...value.groupSeqs, Number(group.seq)] : value.groupSeqs.filter(id => id !== Number(group.seq)) })} />{group.name}
    </label>)}</div>
    {error && <p role="alert">{error} <button type="button" onClick={() => setVersion(v => v + 1)}>다시 시도</button></p>}
    <label className="warehouse-import-new-group"><input type="checkbox" checked={create} onChange={event => { setCreate(event.target.checked); onChange({ ...value, newGroupName: event.target.checked ? '' : undefined }); }} />새 그룹 만들기</label>
    {create && <label className="warehouse-import-group-name">그룹 이름<input type="text" maxLength={320} value={value.newGroupName || ''} placeholder="새 그룹 이름을 입력해주세요" onChange={event => onChange({ ...value, newGroupName: event.target.value })} /></label>}
    <p>여러 그룹을 선택할 수 있습니다. 기존 상품의 그룹은 유지됩니다.</p>
  </fieldset>;
}
